export default __webpack_public_path__ + "static/media/Eamcet-Exam.8fd1f35e.png";